<p *ngFor="let error of errorsDetails$ | async">
  {{ prefix + '.' + error[0] | cxTranslate: getTranslationParams(error[1]) }}
</p>
